import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import Joi from 'joi-full';
import { withRouter } from 'react-router';
import { syncValidateData } from '../../../../common/validator';
import Form from '../components/Form';
import { getActiveType } from '../../../../auth/selectors';

const FORM = 'marketingLeads/form';

const schema = Joi.object().keys({
  id: Joi.string().guid().optional(),
  lead: Joi.string().min(2).required(),
});

const validate = values => syncValidateData(values, schema);

const form = reduxForm({
  form: FORM,
  onSubmitSuccess: (_values, _dispatch, props) => {
    props.router.push(props.baseUrl);
  },
  validate,
});

export default compose(
  connect((state, ownProps) => {
    const activeType = getActiveType(state);
    const initialValues = ownProps.initialValues || {};
    const isNew = !initialValues.id;
    return {
      isBrandLead: initialValues.ownerType === 'brand' || (isNew && activeType === 'brand'),
      isEditable: !initialValues.id || initialValues.ownerType === activeType,
    };
  }),
  withRouter,
  form
)(Form);
